<template>
  <FloatingDropdown
    class="search-dropdown"
    :open="isOpen"
    @open="open"
    @close="isOpen = false"
  >
    <template #toggle>
      <slot>
        <div class="search-dropdown__default-toggle">
          <SearchIcon class="search-dropdown__default-toggle-icon"/>
          <div class="search-dropdown__default-toggle-text">
            {{translate('Hae sivustolta')}}
          </div>
        </div>
      </slot>
    </template>

    <template #default>
      <form
        class="search-dropdown__form"
        :action="action"
        method="get"
      >
        <input
          ref="input"
          type="text"
          name="s"
          class="search-dropdown__input"
        />
        <button
          type="submit"
          class="search-dropdown__submit"
        >
          <ArrowIcon class="search-dropdown__default-toggle-icon"/>
        </button>
      </form>
    </template>

  </FloatingDropdown>
</template>

<script>
  import globals from '../lib/globals';
  import utils from './mixins/utils';
  import LoadSpinner from './components/LoadSpinner';
  import FavouriteCard from './components/FavouriteCard';
  import FloatingDropdown from './components/FloatingDropdown';
  import SearchIcon from './icons/SearchIcon.vue';
  import ArrowIcon from './icons/ArrowIcon.vue';

  export default {
    components: {
    FloatingDropdown,
    LoadSpinner,
    FavouriteCard,
    SearchIcon,
    ArrowIcon
},
    mixins: [utils.translate],
    data() {
      return {
        isOpen: false,
        action: globals.urlHome,
      }
    },
    methods: {
      async open() {
        this.isOpen = true;

        // Wait for dropdown to render.
        await this.$nextTick();

        this.$refs.input.focus();
      },
    },
  }
</script>

<style lang="scss">
  @import "~styles/definitions";

  .search-dropdown {
  }

  .search-dropdown__default-toggle {
    @include font-h-16;
    display: flex;
    align-items: center;
    color: $color-white;

    @include media-breakpoint-up(lg) {
      @include font-h-18;
    }
  }

  .search-dropdown__default-toggle-text {
    display: none;

    @include media-breakpoint-up(xl) {
      display: block;
      margin-left: r(2);
    }
  }

  .search-dropdown__form {
    display: flex;
  }

  .search-dropdown__input {
    @include reset-input(true);
    flex: 1 0 auto;
    padding-left: r(16);
  }

  .search-dropdown__submit {
    @include reset-button(true);
    color: $color-green-2025;
    padding: r(8);
    transition: transform 0.2s;

    &:focus {
      transform: scale(1.2);
    }
  }
</style>
